// SPDX-License-Identifier: AGPL-3.0-or-later

let cachedLocale: string | null = null;
let wholeTryFormat: Intl.NumberFormat;
let tryFormat: Intl.NumberFormat;
let aznFormat: Intl.NumberFormat;
let usdFormat: Intl.NumberFormat;

function cacheFormats(locale: string): void {
	if (locale === cachedLocale) return;
	wholeTryFormat = new Intl.NumberFormat(locale, {maximumFractionDigits: 0});
	tryFormat = new Intl.NumberFormat(locale, {minimumFractionDigits: 2, maximumFractionDigits: 2});
	aznFormat = new Intl.NumberFormat(locale, {minimumFractionDigits: 2, maximumFractionDigits: 2});
	usdFormat = new Intl.NumberFormat(locale, {style: 'currency', currency: 'USD'});
	cachedLocale = locale;
}

// Whole lira without decimals ("98 TL"), any kuruş with two ("49,90 TL").
export function formatShopTry(minor: number, locale: string): string {
	cacheFormats(locale);
	return `${(minor % 100 === 0 ? wholeTryFormat : tryFormat).format(minor / 100)} TL`;
}

export function formatShopAzn(minor: number, locale: string): string {
	cacheFormats(locale);
	return aznFormat.format(minor / 100);
}

// The whole price with its sign ("$4.99", "4,99 $"): a Paddle USD charge is what the buyer pays.
export function formatShopUsd(minor: number, locale: string): string {
	cacheFormats(locale);
	return usdFormat.format(minor / 100);
}
